import React, { Component } from "react";
import { Icon, Modal, Form, Button, Dropdown, Checkbox } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Service from "./service";
import AlertContainer from "react-alert";
import { Can } from "../../modules";
import { BrandGroupDropdown } from "../../components";

const emptyForm = {
  name: "",
  description: "",
  info_url: "",
  price: null,
  tag_id: null,
  can_convert_to_intervention: false,
  brand_group_ids: [],
};

const LEF_LEAD_KIND = {
  apk: 1,
  tires: 2,
  bid: 3,
  brochure: 4,
  contact_request: 5,
  financing: 6,
  warranty: 7,
  keep_me_posted: 8,
  client_satisfaction: 9,
  loyalty: 10,
  mailing: 11,
  quotation: 12,
  maintenance: 13,
  private_lease: 14,
  test_drive: 15,
  repairs: 16,
  showroom_visit: 17,
  taxation: 18,
  callback_request: 19,
  insurance: 20,
  office_quotation: 21,
  office_appointment: 22,
  commercial_leasing: 23,
  other: 24,
  short_lease: 25,
  rental: 26,
  damage: 27,
  car_configurator: 28,
  accessories: 29,
  complaint: 30,
  event: 31,
  telephonic_lead: 32,
  webshop: 33,
  search_request: 34,
  calling_list: 35,
  recall_campaign: 36,
  charging_point: 37,
};

class ServiceModal extends Component {
  state = {
    form:
      this.props.mode === "create"
        ? { ...emptyForm }
        : { ...this.props.service, brand_group_ids: this.props.service.brand_groups?.length > 0 ? this.props.service.brand_groups.map(a => a.id) : [] },
    selectedBrandGroups: this.props.mode === "create" ? [] : this.props.service.brand_groups || [],
    isLoading: false,
    notificationEmail: this.props.notification_email,
    sendToLef: this.props.send_to_lef,
    lefLeadKindId: this.props.lef_lead_kind,
    alertOptions: {
      offset: 20,
      position: "top right",
      theme: "light",
      time: 10000,
      transition: "fade",
    },
  };

  error = msg => {
    this.msg.show(msg, { type: "error" });
  };

  handleChange = (e, data) => {
    const { form } = this.state;

    if (e.target.name === "price") {
      if (e.target.value && isNaN(parseFloat(e.target.value))) return;

      let val = e.target.value.match(new RegExp("^(\\d+\\.?\\d{0,2}).*"));
      form[e.target.name] = val === null ? "" : val[1];
    } else {
      form[e.target.name] = e.target.value;
    }

    this.setState({ form });
  };

  handleCheckboxChange = (e, data) => {
    const { form } = this.state;
    form[data.name] = data.checked;

    this.setState({ form });
  };

  handleDropdownSelect = (_e, { name, value }) => {
    this.setState(state => ({ form: { ...state.form, [name]: value } }));
  };

  handleBrandGroupsChange = (brandGroupIDs, selectedBrandGroups) => {
    this.setState(state => ({ form: { ...state.form, brand_group_ids: brandGroupIDs }, selectedBrandGroups }));
  };

  handleChangeSendToLEF = (e, { checked }) => {
    this.setState({ sendToLef: checked }, () => {
      if (!checked) this.setState({ lefLeadKindId: null });
      else this.setState({ lefLeadKindId: LEF_LEAD_KIND.taxation });
    });
  };

  handleChangeNotificationEmail = e => {
    this.setState({ notificationEmail: e.target.value });
  };

  handleUpdateLocationService = () => {
    const { sendToLef: send_to_lef, notificationEmail: notification_email, lefLeadKindId: lef_lead_kind } = this.state;
    const { service, dealer_location_id, onUpdateService } = this.props;

    this.setState({ isLoading: true }, async () => {
      try {
        const updateSendToLefCall = Service.updateSendToLef({
          send_to_lef,
          lef_lead_kind,
          checkin_service_id: service.id,
          dealer_location_id: dealer_location_id,
        });
        const updateNotificationEmailCall = Service.updateNotificationEmail({
          notification_email,
          checkin_service_id: service.id,
          dealer_location_id: dealer_location_id,
        });

        const [updateSendToLefResponse, updateNotificationEmailResponse] = await Promise.allSettled([updateSendToLefCall, updateNotificationEmailCall]);

        if (updateSendToLefResponse.status === "rejected") {
          const errMsg = updateSendToLefResponse?.reason?.response?.data?.errors?.[0] || "Error updating Send to LEF";

          throw Error(errMsg);
        }

        if (updateNotificationEmailResponse.status === "rejected") {
          const errMsg = updateNotificationEmailResponse?.reason?.response?.data?.errors?.[0] || "Error updating notification email";

          throw Error(errMsg);
        }

        this.setState({ isLoading: false }, () => {
          onUpdateService();
        });
      } catch (error) {
        this.error(error.message);
        this.setState({ isLoading: false });
        console.error("Error updating send to LEF or notification email", error);
      }
    });
  };

  handleSubmit = () => {
    const { form, selectedBrandGroups } = this.state;

    if (form.info_url && !form.info_url.startsWith("https://")) {
      this.error("Only https link are allowed");
      return;
    }

    this.setState({ isLoading: true });
    const requestData = {
      dealer_id: this.props.dealer_id,
      name: form.name,
      description: form.description,
      info_url: form.info_url,
      price: parseFloat(form.price - 0),
      brand_groups: selectedBrandGroups,
      hide_for_lease_appointments: form.hide_for_lease_appointments,
      tag_id: form.tag_id || null,
      can_convert_to_intervention: form.can_convert_to_intervention,
    };
    if (this.props.mode === "create") {
      Service.createService(requestData)
        .then(result => {
          if (result && result.data && result.data.data) {
            this.props.onSubmit();
            this.setState({ isLoading: false });
          }
        })
        .catch(error => {
          console.error("Error creating service.", error);
          this.setState({ isLoading: false });
          error.response.data && error.response.data.errors && this.error(error.response.data.errors[0]);
        });
    } else if (this.props.mode === "edit") {
      requestData.id = this.props.service.id;
      Service.updateService(requestData)
        .then(result => {
          this.props.onSubmit();
          this.setState({ isLoading: false });
        })
        .catch(error => {
          console.error("Error updating service.", error);
          this.setState({ isLoading: false });
          error.response.data && error.response.data.errors && this.error(error.response.data.errors[0]);
        });
    }
  };

  handleDeleteService = () => {
    this.setState({ isLoading: true });
    const requestData = {
      id: this.props.service.id,
    };
    Service.deleteService(requestData)
      .then(result => {
        this.props.onSubmit();
        this.setState({ isLoading: false });
      })
      .catch(error => {
        console.error("Error deleting service.", error);
        this.setState({ isLoading: false });
        error.response.data && error.response.data.errors && this.error(error.response.data.errors[0]);
      });
  };

  handleDisableService = () => {
    this.setState({ isLoading: true });
    const requestData = {
      id: this.props.service.id,
      dealer_location_id: this.props.dealer_location_id,
    };
    Service.locationDisable(requestData)
      .then(result => {
        this.props.onSubmit();
        this.setState({ isLoading: false });
        this.props.onUpdateService();
      })
      .catch(error => {
        console.error("Error disabling service.", error);
        this.setState({ isLoading: false });
        error.response.data && error.response.data.errors && this.error(error.response.data.errors[0]);
      });
  };

  isSendToLefVisible = () => {
    const { mode, list, selectedLocation } = this.props;

    if (mode === "create") return false;

    if (list === "location") return selectedLocation.is_lef_enabled && selectedLocation.lef_account_number;

    return false;
  };

  getLefLeadKindDropdownOptions = () => Object.entries(LEF_LEAD_KIND).map(([key, value]) => ({ text: this.props.t(key).message || key, value, key: value }));

  handleChangeLefLeadKindIdChange = (_evt, { value: lefLeadKindId }) => this.setState({ lefLeadKindId });

  render() {
    const { t, tagOptions, mode, list } = this.props;
    const { form, notificationEmail, sendToLef, lefLeadKindId, isLoading } = this.state;

    return (
      <Modal size="small" dimmer="inverted" onClose={this.props.onClose} open={true} closeOnDimmerClick={false}>
        <Modal.Header>
          {mode === "create"
            ? t("add_new_check_in_service").message || "Add new online check-in service"
            : t("edit_check_in_service").message || "Edit online check-in service"}
        </Modal.Header>
        <Modal.Content>
          <AlertContainer ref={a => (this.msg = a)} {...this.state.alertOptions} />
          <Form>
            <Form.Field>
              <Form.Input
                name="name"
                disabled={list === "location"}
                placeholder={t("check_in_service_name").message || "Online Check-in service name"}
                defaultValue={form.name}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                name="description"
                disabled={list === "location"}
                placeholder={t("check_in_service_description").message || "Online Check-in service description"}
                defaultValue={form.description}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field>
              <BrandGroupDropdown value={form.brand_group_ids} onChange={this.handleBrandGroupsChange} disabled={list === "location"} />
            </Form.Field>

            <Form.Field>
              <Dropdown
                placeholder={t("select_tag").message || "Select tag"}
                selection
                fluid
                clearable
                name="tag_id"
                disabled={list === "location"}
                options={tagOptions}
                value={form.tag_id}
                onChange={this.handleDropdownSelect}
              />
            </Form.Field>

            <Form.Field>
              <Form.Input
                name="info_url"
                disabled={list === "location"}
                placeholder={t("info_url").message || "Info URL"}
                defaultValue={form.info_url}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field>
              <Form.Input
                name="price"
                disabled={list === "location"}
                placeholder={(t("price").message || "Price") + " " + (t("no_vat_price").message || "(excl. VAT)")}
                value={form.price || ""}
                onChange={this.handleChange}
              />
            </Form.Field>
            <Form.Field>
              <Checkbox
                onChange={this.handleCheckboxChange}
                disabled={list === "location"}
                toggle
                label={t("hide_for_lease_appointments").message || "Hide for lease appointments"}
                name="hide_for_lease_appointments"
                checked={form.hide_for_lease_appointments}
              />
            </Form.Field>
            <Form.Field>
              <Checkbox
                onChange={this.handleCheckboxChange}
                disabled={list === "location"}
                toggle
                label={t("convert_to_intervention").message || "Convert to intervention"}
                name="can_convert_to_intervention"
                checked={form.can_convert_to_intervention}
              />
            </Form.Field>
            {this.isSendToLefVisible() && (
              <>
                <Form.Field>
                  <Checkbox onChange={this.handleChangeSendToLEF} toggle label={t("send_to_lef").message || "Send to LEF"} name="send_to_lef" checked={sendToLef} />
                </Form.Field>
                {sendToLef && (
                  <Dropdown
                    selection
                    fluid
                    options={this.getLefLeadKindDropdownOptions()}
                    selectOnBlur={false}
                    value={lefLeadKindId}
                    className="lef-kind-dropdown"
                    placeholder={t("lef_lead_kind").message || "LEF Lead Kind ID"}
                    onChange={this.handleChangeLefLeadKindIdChange}
                  />
                )}
              </>
            )}

            {list === "location" && mode === "edit" && (
              <Form.Field>
                <Form.Input
                  name="notification_email"
                  placeholder={t("notification_email").message || "Notification email"}
                  value={notificationEmail}
                  onChange={this.handleChangeNotificationEmail}
                />
              </Form.Field>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.onClose} floated="left" color="red">
            <Icon name="close" />
            {t("cancel").message || "Cancel"}
          </Button>
          {mode === "edit" && list === "dealer" && (
            <Can I="delete" the="check_in_service">
              <Button onClick={this.handleDeleteService} loading={isLoading} color="red">
                <Icon name="trash" />
                {t("delete").message || "Delete"}
              </Button>
            </Can>
          )}

          {mode === "edit" && list === "location" && (
            <Can I="update" the="check_in_service">
              <Button onClick={this.handleDisableService} loading={isLoading} color="red">
                {t("disable").message || "Disable"}
              </Button>
            </Can>
          )}

          {mode === "create" && list !== "location" && (
            <Can I="create" the="check_in_service">
              <Button loading={isLoading} disabled={isLoading || !form.name || !form.description} onClick={this.handleSubmit} color="green">
                <Icon name="checkmark" />
                {t("save").message || "Save"}
              </Button>
            </Can>
          )}

          {mode === "edit" && list !== "location" && (
            <Can I="update" the="check_in_service">
              <Button loading={isLoading} disabled={isLoading || !form.name || !form.description} onClick={this.handleSubmit} color="green">
                <Icon name="checkmark" />
                {t("save").message || "Save"}
              </Button>
            </Can>
          )}

          {mode === "edit" && list === "location" && (
            <Can I="update" the="check_in_service">
              <Button loading={isLoading} disabled={isLoading} onClick={this.handleUpdateLocationService} color="green">
                <Icon name="checkmark" />
                {t("save").message || "Save"}
              </Button>
            </Can>
          )}
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation()(ServiceModal);
